import './styles.scss';

function Location() {

    return (
        <div className="container-location">
            <h1>Locais de Atendimento</h1>
            <p>Clínica IVA - Rua Altino Serbeto de Barros, 173, Edf. Atlantis, Salas 1002 e 1005. Itaigara - Salvador/BA
            </p>
            <p>Clínica CLAP – Avenida Tancredo Neves,805-A, Centro Médico Iguatemi, Sala 303. Caminho das Árvores, Salvador/BA</p>
            <a className='btnSchedule' href="https://wa.me/5571997303062" target="_blank" rel="noopener noreferrer">Agendar Consulta</a>
        </div>
    );
}

export default Location;
